import { render, staticRenderFns } from "./JudgeDigitalReply.vue?vue&type=template&id=09ebb4cd&"
import script from "./JudgeDigitalReply.vue?vue&type=script&lang=js&"
export * from "./JudgeDigitalReply.vue?vue&type=script&lang=js&"
import style0 from "./JudgeDigitalReply.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports